export enum NotificationTypeEnum {
    EIGHTY_PC = "80PC",
    HUNDRED_PC = "100PC",
    OUT_OF_BUNDLE = "OOB",
    INVOICE = "INV",
    OTHER = "OTHER"
}